import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { digger } from '@cbre/digger';
import { GroupBase } from '../../../models/blueprint.model';
import { DataObject, ReportInfo, ReportRecord, ReportView, TemplateProjectionMap } from '../../../models/report.model';
import { TemplateField } from '../../../models/template.model';
import { ReportFieldFormatterService } from '../../../report-field-formatter.service';
import { onDrop } from '../presentation-report.helper';

@Component({
  selector: 'rep-presentation-dynamic-view-body',
  templateUrl: './record-body.component.html',
  styleUrls: ['./record-body.component.scss'],
  standalone: false,
})
export class PresentationDynamicViewBodyComponent implements OnChanges, OnInit, OnDestroy {
  @Input() recordNumber: number;
  @Input() reportData: ReportInfo;
  @Input() currentView: ReportView;
  @Input() headerGroups: GroupBase<TemplateField>[];
  @Input() bodyGroups: GroupBase<TemplateField>[];
  @Input() imageGroups: GroupBase<TemplateField>[];
  @Input() footerGroups: GroupBase<TemplateField>[];
  @Input() reportLocale: number;
  @Input() templateProjectionMap: TemplateProjectionMap;
  @Output() removeRecord: EventEmitter<ReportRecord> = new EventEmitter<ReportRecord>();
  @Output() reportReordered: EventEmitter<ReportRecord[]> = new EventEmitter<ReportRecord[]>();
  headerFields: TemplateField[];
  tableFields: GroupBase<TemplateField>;
  bodyAttributes: GroupBase<TemplateField>;
  footerAttributes: TemplateField[];
  allFields: TemplateField[];
  recordData: ReportRecord;
  templateTableConfigs: DataObject;
  tableData: any[];

  constructor(
    private router: Router,
    private reportFieldFormatterService: ReportFieldFormatterService
  ) {}

  ngOnChanges({ recordNumber, currentView, reportData, bodyGroups, footerGroups }: SimpleChanges) {
    if (
      (!!reportData && !!reportData.currentValue) ||
      (!!recordNumber && !!recordNumber.currentValue) ||
      (!!currentView && !!currentView.currentValue) ||
      (!!bodyGroups && !!bodyGroups.currentValue) ||
      (!!footerGroups && !!footerGroups.currentValue)
    ) {
      this.tableFields = null;
      if (!!this.bodyGroups) {
        const [bodyAttributes, tableFields] = this.bodyGroups;
        this.tableFields = tableFields;
        const fields = bodyAttributes.fields.filter(field => {
          return this.reportFieldFormatterService.isFieldVisible(this.recordData, {
            templateId: this.currentView.templateId,
            field,
          });
        });
        this.bodyAttributes = { ...bodyAttributes, fields };
        this.allFields = [].concat(...(this.bodyGroups || []).map(group => group.fields));
      }
      if (!!this.reportData && !!this.reportData.records) {
        this.recordData = this.reportData.records[this.recordNumber - 1];
      }
      if (!!this.reportData && !!this.reportData.records && this.tableFields && this.tableFields.tableConfigs) {
        const data = digger(this.recordData, this.tableFields.tableConfigs.dataKey);
        // reviewing if data is an array, will prevent the table rows from throwing
        // errors when angular change detection gets triggered and data is an actual
        // object. (in HTML we have tableData.length)
        this.tableData = Array.isArray(data) ? data : null;
      }
      if (!!this.footerGroups) {
        this.footerAttributes = [].concat(...(this.footerGroups || []).map(group => group.fields));
      }

      this.headerFields = []
        .concat(...(this.headerGroups || []).map(group => group.fields))
        .sort((a, b) => a.options.headerSortOrder - b.options.headerSortOrder);
    }
  }

  ngOnInit(): void {
    // required by angular-l10n
  }

  ngOnDestroy(): void {
    // required by angular-l10n
  }

  goToRecordDetails(recordData: DataObject) {
    // TODO (Ramakrishna): need to implement pipe as like in condensed view for link navigation
    const { entity } = this.reportData;
    const currentRecordId = recordData.entity.id;
    const url = `/records/${entity}/${currentRecordId}/details`;
    this.router.navigateByUrl(url);
  }

  public onReorder(cdkDragDropEvent: CdkDragDrop<Array<{ [key: string]: any }>>, recordData) {
    onDrop(cdkDragDropEvent, recordData, this.reportData, this.reportReordered, this.recordNumber);
  }
}
